var _style, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 123 38",
    style: {
      enableBackground: "new 0 0 123 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{clip-path:url(#SVGID_00000020400325531677438480000005342743160989314215_);}\r\n\t.st2{fill:url(#SVGID_00000031192582265175967530000012055258731680759438_);}\r\n\t.st3{fill:url(#SVGID_00000098199781110744355580000009347275986136091559_);}\r\n\t.st4{fill:url(#SVGID_00000020400773239622329500000007747501249192748713_);}\r\n\t.st5{fill:url(#SVGID_00000100372928597887989880000014842651844159586995_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,31v-1.1l8.1-9.7l-8.1-9.7V9.4h4.3l6.5,7.7l6.4-7.7h4.3v1.1l-8.2,9.7l8.2,9.7V31h-4.3l-6.5-7.6L32.7,31 H28.4z M52.5,31V9.4h19.9v4H56.5v4.8h12.8v4H56.5V27h15.9v4H52.5z M79,31c-0.8,0-1.5-0.2-2.1-0.6s-1.1-0.9-1.5-1.5s-0.6-1.3-0.6-2.1 V13.6c0-0.8,0.2-1.4,0.6-2.1c0.4-0.6,0.9-1.1,1.5-1.5s1.3-0.6,2.1-0.6h17.4v4H79.8c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.4-0.3,0.8 V26c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3h16.5v4L79,31L79,31z M103,31c-0.8,0-1.5-0.2-2.1-0.6s-1.1-0.9-1.5-1.5 s-0.6-1.3-0.6-2.1V13.6c0-0.8,0.2-1.4,0.6-2.1c0.4-0.6,0.9-1.1,1.5-1.5s1.3-0.6,2.1-0.6h13.3c0.8,0,1.4,0.2,2.1,0.6 c0.6,0.4,1.2,0.9,1.5,1.5c0.4,0.6,0.6,1.3,0.6,2.1v13.3c0,0.8-0.2,1.5-0.6,2.1s-0.9,1.1-1.5,1.5s-1.3,0.6-2.1,0.6H103V31z M103.1,27 H116c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3V13.8c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.2-0.1-0.3-0.1h-12.9c-0.1,0-0.2,0-0.3,0.1 c-0.1,0.1-0.1,0.1-0.1,0.2v12.9c0,0.1,0,0.2,0.1,0.3C102.9,27,103,27,103.1,27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 4,
    width: 21,
    height: 28
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076604071974934570730000013276866864721828492_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000076604071974934570730000013276866864721828492_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000188416653801532610000005045962749980863379_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.0423,
    y1: -539.4814,
    x2: 10.1329,
    y2: -524.3938,
    gradientTransform: "matrix(1 0 0 -1 0 -520)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDCB02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#363F00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000188416653801532610000005045962749980863379_)"
    },
    d: "M17.1,19.5c1.5-0.8,2.8-2.2,3-3.7 c0.3-2.7-1.3-4.7-3.5-5.6C14.1,9.1,15.8,9.9,6,7.3C1.3,6,1,4.8,1.1,4c-1.3,0.8-1.7,5.4,0.6,6.8s6.8,1.7,12.5,3.4 C19.1,15.6,18.4,18.3,17.1,19.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116944589270916869230000006861272870885512623_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.412,
    y1: -551.9898,
    x2: 10.5291,
    y2: -534.4807,
    gradientTransform: "matrix(1 0 0 -1 0 -520)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDCB02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#363F00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116944589270916869230000006861272870885512623_)"
    },
    d: "M18.1,20.3c-0.4-0.3-0.9-0.5-1.4-0.6 C9.6,18,9,18,6.6,17.4C0.2,15.9,1,14.5,0.8,14c-1.2,1.3-1.2,5.3,1,6.5c2.7,1.5,7.4,1.9,13.3,3.4c1.9,0.5,3.1,1.1,3.9,1.8 c0.9,0.8,1.2,1.9,0.5,2.8c-0.6,0.8-2.3,0.7-4.2,0.4c-3.3-0.5-7.5-1.4-8.7-1.8c-5.3-1.5-5.7-2.9-5.8-3.4c-1.2,1.3-1.2,5.3,1,6.5 c1.7,1,3.4,1.5,7,1.7c2.6,0.2,7.4,0.3,9.7-2.1c0.2-0.2,2-1.6,2.4-4C21.3,23.5,20.1,21.4,18.1,20.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024683118864575172050000003360577770149289635_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.2379,
    y1: -539.6767,
    x2: 15.284,
    y2: -534.0553,
    gradientTransform: "matrix(1 0 0 -1 0 -520)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDCB02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#363F00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024683118864575172050000003360577770149289635_)"
    },
    d: "M12.5,18.7L12.5,18.7 c2.1,0.5,4.2,0.9,4.2,0.9h0.1c0.1-0.1,0.2-0.1,0.3-0.2c1.2-1.2,2-3.9-3-5.3c-0.3-0.1-0.7-0.2-1-0.3 C14.5,14.5,16.5,17.6,12.5,18.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047766986071682462770000016541234105078151296_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.6325,
    y1: -549.1038,
    x2: 16.6693,
    y2: -543.6368,
    gradientTransform: "matrix(1 0 0 -1 0 -520)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDCB02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#363F00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047766986071682462770000016541234105078151296_)"
    },
    d: "M13.8,28.4c-0.1,0.1-0.2,0.1-0.3,0.2 c0.6,0.1,1.2,0.2,1.8,0.3c1.9,0.3,3.6,0.4,4.2-0.4c0.7-0.9,0.5-2-0.5-2.8c-1.6-1.3-3.6-1.7-5.6-2.2 C14.9,24.2,16.1,26.5,13.8,28.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dedf59b6d87c27a62a0b8a02eed4f175.svg";
export { ForwardRef as ReactComponent };